/* eslint-disable camelcase */

import { api } from '@/utils/api'

import { ApiResponseHandler, Postable } from './ApiInterfaces'
import { ApiBase, ResponseError } from './ApiBase'

/**
 * ATRリクエストAPI
 * */
export namespace ApiTaCt0X0 {
  // POST parameters
  export namespace Post {
    export type EvalType = 'word' | 'sentence'

    // API Request
    export interface Request {
      body: {
        evalType: EvalType // 判定のタイプ、特定の文字列のみ
        stimid: string // 判定に用いるファイルパス、コンテンツから与えられる
        adjust: number // 発音点数調整値、コンテンツから与えられる
        rhythm_adjust: number // 発音リズム点数調整値、コンテンツから与えられる
        accent_adjust: number // 発音抑揚点数調整値、コンテンツから与えられる
        snd: string // 音声データをbase64エンコードした文字列
      }
    }

    // API Response
    interface Scores {
      score: string // 発音スコア、整数値の文字列型
      rhythm_score: string // リズムスコア、整数値の文字列型
      accent_score: string // 抑揚スコア、整数値の文字列型
    }
    export interface Response {
      status: string // 'SUCCESS' or 'ERROR'
      data: Scores
    }
  }

  // API Path
  export const path: string = '/ta/requestATR'

  // API本体
  export class Api extends ApiBase implements Postable<Post.Request, Post.Response, ResponseError> {
    // POST
    public post<R>(
      params: Post.Request,
      successHandler: ApiResponseHandler<Post.Response, R>,
      errorHandler: ApiResponseHandler<ResponseError, R>
    ): Promise<R | null> {
      // 成功時のレスポンス構造サンプル
      const validationSample: Post.Response = {
        status: '',
        data: {
          score: '',
          rhythm_score: '',
          accent_score: '',
        },
      }
      // エラー時のレスポンス構造サンプル
      const validationErrorSample: ResponseError = {
        error: {
          messageId: '',
          message: '',
        },
      }

      // API呼び出し
      return this.callbackWrapper<Post.Response, ResponseError, R>(
        api.post<Post.Response>(path, params.body),
        successHandler,
        errorHandler,
        validationSample,
        validationErrorSample
      )
    }
  }
}
